import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import SobreNosotros from "../pages/legal/SobreNosotros";
import Privacidad from "../pages/legal/Privacidad";
import Terminos from "../pages/legal/Terminos";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/sobre-nosotros",
    element: <SobreNosotros />,
  },
  {
    path: "/privacidad",
    element: <Privacidad />,
  },
  {
    path: "/terminos",
    element: <Terminos />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
